import { render, staticRenderFns } from "./InvesmentPerformanceDisclosureCopy.vue?vue&type=template&id=79247f7a"
import script from "./InvesmentPerformanceDisclosureCopy.vue?vue&type=script&lang=ts"
export * from "./InvesmentPerformanceDisclosureCopy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports